export default function Footer() {
     const currentYear = new Date().getFullYear();

     return (
          <footer className="sticky-footer">
               <div className="container my-auto">
                    <div className="copyright text-center my-auto">
                         <span>
                              Copyright &copy; {currentYear} Vijaya Diagnostic Centre. All rights reserved.
                         </span>
                         {/* <div className="mt-1">
                              <small className="text-muted">
                                   Powered by VDC Healthcare Solutions
                              </small>
                         </div> */}
                    </div>
               </div>
          </footer>
     );
}
